import { Component, OnInit, AfterContentChecked, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ParentGuardianDetails } from '../../models/parent-guardian-details';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { SingleResultApiResponse } from 'src/app/shared/models/api-response.model';
import { ErrorResponse } from 'src/app/shared/models/error.model';
import { Router, ActivatedRoute } from '@angular/router';
import { Relationship } from 'aws-sdk/clients/configservice';
import { Country } from 'src/app/shared/models/lookup-data.model';
import { Address, AddressConfig, AddressErrors } from '../../shared/address/address.model';
import { PersonDetails, PersonDetailsConfig, PersonDetailsErrors } from '../../shared/person-details/person-details.model';
import { PhoneNumberDetails, PhoneNumberConfig, PhoneNumberErrors } from '../../shared/phone-number/phone-number.model';
import { Store } from '@ngrx/store';
import { Action_ApplicationSectionSaved } from '../../state/actions';
import { Observable, Subscription } from 'rxjs';
import { ModalService } from 'src/app/shared/services/modal.service';
import { compareParentGuardianDetails } from '../../shared/utils/ModelUtils';
import { FormService } from 'src/app/shared/services/form.service';
import { ParentAddress, ParentAddressErrors, ParentAddressConfig } from '../../models/parent-guardian-details';
import { debounceTime } from 'rxjs/operators';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Component({
  selector: 'online-app-parent-guardian-details-edit',
  templateUrl: './parent-guardian-details-edit.component.html',
  host: {
    class: 'application-section-component'
  },
  styleUrls: ['./parent-guardian-details-edit.component.scss']
})
export class ParentGuardianDetailsEditComponent implements OnInit, AfterContentChecked, OnDestroy {

  parentGuardianDetailsFormGroup: FormGroup;
  relationships: Relationship[];
  isFormSubmitted = false;
  applicationId: number;
  parentGuardianId: number;
  isSaveSuccessful = false;
  selectedRelationship = '';
  isScrollDone = false;
  isSubmittedApplication = false;
  showChangeImpactModal: boolean = false;


  initialParentDetails: PersonDetails = {
    relationship: undefined,
    otherRelationship: undefined,
    givenName: undefined,
    isRefusedAusVisaBefore: undefined,
    visaRefusalDetails: undefined,
    familyName: undefined,
    preferredName: undefined,
    dateOfBirth: undefined,
    gender: undefined,
    countryOfBirth: undefined,
    nationality: undefined,
    hasPassport: undefined,
    passportNumber: undefined,
    passportExpiryDate: undefined,
    emailAddress: undefined,
    onlyHasOneName: undefined
  };

  initialPhoneNumber: PhoneNumberDetails = {
    mobileCountryCode: undefined,
    mobilePhoneNumber: undefined,
    homeCountryCode: undefined,
    homePhoneNumber: undefined
  };

  parentDetailsConfig: PersonDetailsConfig = {
    isRelationshipRequired: true,
    isRefusedAusVisaBefore: true,
    title: 'Person Details',
    titleAdditionalInfo: '1 of 4',
    countries: [],
    nationalityCountries: [],
    relationships: []
  };

  parentDetailsErrors: PersonDetailsErrors = {};

  parentDetailsData: PersonDetails;
  initialParentDetailsData: PersonDetails;

  phoneNumberConfig: PhoneNumberConfig = {
    title: 'Phone Number',
    titleAdditionalInfo: '2 of 4',
    countries: [],
  };

  phoneNumberErrors: PhoneNumberErrors = {};

  phoneNumberData: PhoneNumberDetails;
  initialPhoneNumberData: PhoneNumberDetails;

  overseasAddressErrors: AddressErrors = {};
  australianAddressErrors: AddressErrors = {};

  overseasAddressConfig: AddressConfig = {
    isAustralianAddress: false,
    title: 'Overseas Address',
    titleAdditionalInfo: '4 of 4',
    idPrefix: 'overseas-address-'
  };

  overseasAddressData: Address;
  initialOverseasAddressData: Address;

  australianAddressConfig: AddressConfig = {
    isAustralianAddress: true,
    title: 'Australian Address',
    titleAdditionalInfo: '3 of 4',
    idPrefix: 'aus-address-'    
  };

  australianAddressData: Address;
  initialAustralianAddressData: Address;


  //Mn-936
  currentAddressData: ParentAddress = {};
  currentAddressConfig: ParentAddressConfig = {
    isSubmittedApplication: false,
    isParent: false,
    title: "Current Address",
    titleAdditionalInfo: '3 of 4'
  };
  currentAddressErrors: ParentAddressErrors = {};



  initialOverseasAddressValue: Address = {
    line1: undefined,
    line2: undefined,
    suburb: undefined,
    state: undefined,
    postcode: undefined,
    country: undefined,
    isCurrentAddress: undefined
  };

  initialAustralianAddressValue: Address = {
    line1: undefined,
    line2: undefined,
    suburb: undefined,
    state: undefined,
    postcode: undefined,
    country: undefined,
    isCurrentAddress: undefined
  };
  
  private subscriptionsToDispose: Subscription[] = [];
  schoolProgramTypeStr: string;

  @ViewChild('resolve') resolve: ElementRef;
  constructor(private formBuilder: FormBuilder,
    private store: Store<any>,
    private applicationService: ApplicationService,
    private modalService: ModalService,
    private formService: FormService,
    private router: Router,
    private utilityService: UtilityService,
    private activatedRoute: ActivatedRoute) {

    this.activatedRoute.parent.parent.params.subscribe(params => {
      this.applicationId = +params['id'];
    });

    this.activatedRoute.params.subscribe(params => {
      this.parentGuardianId = +params['parentGuardianId'];

      if (!this.parentGuardianId) {
        this.parentGuardianId = 0;
      }

    });

  }

  ngOnInit() {

    const countries = this.activatedRoute.snapshot.data['countries'];

    //let relationships = this.activatedRoute.snapshot.data['relationshipTypes'];
    let relationships = this.activatedRoute.snapshot.data['relationshipTypes'].filter(rel => rel.IsParent || rel.IsDirectRelative || rel.IsParentNomination || rel.IsHomestay || rel.Code == 'AGENT')


    const noRelationship = {
      Code: '',
      Description: 'Please select',
      IsDirectRelative: false,
      IsHomestay: false,
      IsParent: false,
      IsParentNomination: false,
      IsSoftDeleted: false
    };

    // mn-346 : as this stage do not set IsSoftDelete = 1 in db for these items, as other page/logic MAY also use them
    // const excludeRelationshipList = ['Husband', 'Wife', 'Other'];

    // excludeRelationshipList.forEach(function (excl) {
    //   relationships = relationships.filter(obj => obj.Description !== excl);
    // });

    relationships = relationships.filter(r => !r.IsParent);

    relationships.unshift(noRelationship);
    // this.parentDetailsConfig.countries = countries;

    this.parentDetailsConfig.relationships = relationships;

    this.parentDetailsConfig.countries = [this.getDefaultCountry(), ...countries];

    this.phoneNumberConfig.countries = [this.getDefaultCountry(), ...countries];

    this.overseasAddressConfig.countries = [this.getDefaultCountry(), ...countries];


    // this.overseasAddressConfig.countries = countries;


    this.parentGuardianDetailsFormGroup = this.formBuilder.group({
      parentDetails: this.initialParentDetails,
      phoneNumber: this.initialPhoneNumber,
      australianAddress: this.initialAustralianAddressValue,
      overseasAddress: this.initialOverseasAddressValue,
      currentAddress: this.currentAddressData,
    });

    this.subscriptionsToDispose.push(
      this.parentGuardianDetailsFormGroup.get('parentDetails').valueChanges
      .pipe(debounceTime(250))
      .subscribe(data => {  
        const isRelationshipChanged = data.relationship !== this.selectedRelationship;
  
        if (isRelationshipChanged) {
          this.selectedRelationship = data.relationship;
  
          this.applicationService.getParent(this.applicationId, data.relationship)
            .subscribe((response: SingleResultApiResponse) => {
  
              if (response.Result) {
                const { GivenName, FamilyName } = response.Result;
                const parentDetailsData = { ...data };
                parentDetailsData.givenName = GivenName;
                parentDetailsData.familyName = FamilyName;
                this.parentDetailsData = parentDetailsData;
              }
  
            }, (errorResponse: ErrorResponse) => {
          });  
        }
  
      })
    );

    this.subscriptionsToDispose.push(
      this.parentGuardianDetailsFormGroup.get('australianAddress').valueChanges
      .pipe(debounceTime(250))
      .subscribe(data => {
        if (data.isCurrentAddress) {
          const overseasAddressData = { ...this.parentGuardianDetailsFormGroup.get('overseasAddress').value };
          if (overseasAddressData.isCurrentAddress) {
            overseasAddressData.isCurrentAddress = false;
            this.overseasAddressData = overseasAddressData;
          }
        }
      })
    );
    
    this.subscriptionsToDispose.push(
      this.parentGuardianDetailsFormGroup.get('overseasAddress').valueChanges
      .pipe(debounceTime(250))
      .subscribe(data => {
        if (data.isCurrentAddress) {
          const australianAddressData = { ...this.parentGuardianDetailsFormGroup.get('australianAddress').value };
          if (australianAddressData.isCurrentAddress) {
            australianAddressData.isCurrentAddress = false;
            this.australianAddressData = australianAddressData;
          }
        }
      })
    );


    if (this.parentGuardianId > 0) {
      this.applicationService.getParentGuardianDetails(this.applicationId, this.parentGuardianId)
        .subscribe((response: SingleResultApiResponse) => {

          const parentGuardianDetails = <ParentGuardianDetails>response.Result;
          this.updateFormValuesFromParentGuardianDetails(parentGuardianDetails);

        }, (err) => {
          console.error(err);
        }
        );
    }

    this.applicationService.getApplicationDetails(this.applicationId)
      .subscribe((response: SingleResultApiResponse) => {
        if (response.Result) {

          this.isSubmittedApplication = response.Result.ApplicationStatus === 'Submitted';

          this.schoolProgramTypeStr = response.Result.ApplicationNumber.indexOf('S-') >= 0 ? 'International' : (response.Result.ApplicationNumber.indexOf('A-') >= 0 ? 'StudyAbroad' : '');

          if (this.isSubmittedApplication) {
            this.parentGuardianDetailsFormGroup.disable();

            const submittedParentDetailsConfig = { ...this.parentDetailsConfig };
            submittedParentDetailsConfig.isSubmittedApplication = true;
            this.parentDetailsConfig = submittedParentDetailsConfig;


            const submittedPhoneNumberConfig = { ...this.phoneNumberConfig };
            submittedPhoneNumberConfig.isSubmittedApplication = true;
            this.phoneNumberConfig = submittedPhoneNumberConfig;

            const submittedAustralianAddressConfig = { ...this.australianAddressConfig };
            submittedAustralianAddressConfig.isSubmittedApplication = true;
            this.australianAddressConfig = submittedAustralianAddressConfig;


            const submittedOverseasAddressConfig = { ...this.overseasAddressConfig };
            submittedOverseasAddressConfig.isSubmittedApplication = true;
            this.overseasAddressConfig = submittedOverseasAddressConfig;

          }
        }
      }, err => {
        console.error(err);
      });


  }

  ngOnDestroy() {
    this.subscriptionsToDispose.forEach(s => s.unsubscribe());
  }

  onCloseModal() {
    this.showChangeImpactModal = false;
    this.router.navigate(['/applications', this.applicationId, 'edit', 'parent-guardian-details']);
  }

  getDefaultCountry(): Country {
    return {
      Id: '',
      Code: '',
      Description: 'Please select',
      Status: '',
      IsAgentMandatory: false,
      CanStudyAbroad: false,
      PhoneCode: 0,
      IsDeleted: false
    };
  }

  reloadInitialData() {

    if (this.parentGuardianId > 0) {
      this.applicationService.getParentGuardianDetails(this.applicationId, this.parentGuardianId)
        .subscribe((response: SingleResultApiResponse) => {
          this.updateInitialData(response.Result);
        }, err => {
          console.error(err);
        });
    }

  }

  updateInitialData(parentGuardianDetails: ParentGuardianDetails): void {

    const parentDetailsData = this.getPersonDetailsFromParentGuardianDetails(parentGuardianDetails);
    const phoneNumberData = this.getPhoneNumberDetailsFromParentGuardianDetails(parentGuardianDetails);
    const australianAddressData = this.getAustralianAddressFromParentGuardianDetails(parentGuardianDetails);
    const overseasAddressData = this.getOverseasAddressFromParentGuardianDetails(parentGuardianDetails);

    this.initialParentDetailsData = { ...parentDetailsData };
    this.initialPhoneNumberData = { ...phoneNumberData };
    this.initialAustralianAddressData = { ...australianAddressData };
    this.initialOverseasAddressData = { ...overseasAddressData };
  }



  getAustralianAddressFromParentGuardianDetails(parentGuardianDetails: ParentGuardianDetails): Address {
    return {
      line1: parentGuardianDetails.AustralianAddressLine1,
      line2: parentGuardianDetails.AustralianAddressLine2,
      suburb: parentGuardianDetails.AustralianSuburb,
      state: parentGuardianDetails.AustralianState,
      postcode: parentGuardianDetails.AustralianPostcode,
      country: parentGuardianDetails.OverseasCountryId,
      isCurrentAddress: parentGuardianDetails.IsAustralianAddressCurrentAddress
    };
  }

  getOverseasAddressFromParentGuardianDetails(parentGuardianDetails: ParentGuardianDetails): Address {
    return {
      line1: parentGuardianDetails.OverseasAddressLine1,
      line2: parentGuardianDetails.OverseasAddressLine2,
      suburb: parentGuardianDetails.OverseasSuburbTown,
      state: parentGuardianDetails.OverseasStateProvinceRegion,
      postcode: parentGuardianDetails.OverseasPostcode,
      country: parentGuardianDetails.OverseasCountryId,
      isCurrentAddress: parentGuardianDetails.IsOverseasAddressCurrentAddress
    };
  }

  getPersonDetailsFromParentGuardianDetails(parentGuardianDetails: ParentGuardianDetails): PersonDetails {

    this.selectedRelationship = parentGuardianDetails.RelationshipCode;

    return {
      relationship: parentGuardianDetails.RelationshipCode,
      otherRelationship: parentGuardianDetails.OtherRelationship,
      givenName: parentGuardianDetails.GivenName,
      familyName: parentGuardianDetails.FamilyName,
      onlyHasOneName: parentGuardianDetails.OnlyHasOneName,
      preferredName: parentGuardianDetails.PreferredName,
      isRefusedAusVisaBefore: parentGuardianDetails.IsRefusedAusVisaBefore,
      visaRefusalDetails: parentGuardianDetails.VisaRefusalDetails,
      dateOfBirth: parentGuardianDetails.DateOfBirth,
      gender: parentGuardianDetails.Gender,
      countryOfBirth: parentGuardianDetails.CountryOfBirthId,
      nationality: parentGuardianDetails.CountryOfNationalityId,
      hasPassport: parentGuardianDetails.HasPassport,
      passportNumber: parentGuardianDetails.PassportNumber,
      passportExpiryDate: parentGuardianDetails.PassportExpiryDate,
      emailAddress: parentGuardianDetails.EmailAddress,
    };
  }

  getPhoneNumberDetailsFromParentGuardianDetails(parentGuardianDetails: ParentGuardianDetails): PhoneNumberDetails {
    return {
      mobileCountryCode: parentGuardianDetails.MobileCountryCode,
      mobilePhoneNumber: parentGuardianDetails.MobilePhoneNumber,
      homeCountryCode: parentGuardianDetails.HomeCountryCode,
      homePhoneNumber: parentGuardianDetails.HomePhoneNumber
    };
  }


  updateFormValuesFromParentGuardianDetails(parentGuardianDetails: ParentGuardianDetails): void {

    this.parentDetailsData = this.getPersonDetailsFromParentGuardianDetails(parentGuardianDetails);
    this.phoneNumberData = this.getPhoneNumberDetailsFromParentGuardianDetails(parentGuardianDetails);
    this.australianAddressData = this.getAustralianAddressFromParentGuardianDetails(parentGuardianDetails);
    this.overseasAddressData = this.getOverseasAddressFromParentGuardianDetails(parentGuardianDetails);

    //console.log('this.australianAddressData: ', this.australianAddressData);
    //console.log('this.overseasAddressData: ', this.overseasAddressData);

    //2019-08-21
    if (this.australianAddressData.isCurrentAddress) {
      this.currentAddressData.AddressLine1 = this.australianAddressData.line1;
      this.currentAddressData.AddressLine2 = this.australianAddressData.line2;
      this.currentAddressData.IsAustralianAddress = true;
      this.currentAddressData.Postcode = this.australianAddressData.postcode;
      this.currentAddressData.StateProvinceRegion = this.australianAddressData.state;
      this.currentAddressData.SuburbTownCity = this.australianAddressData.suburb;
      this.currentAddressData.CountryId = this.australianAddressData.country;
    }
    else {
      this.currentAddressData.AddressLine1 = this.overseasAddressData.line1;
      this.currentAddressData.AddressLine2 = this.overseasAddressData.line2;
      this.currentAddressData.IsAustralianAddress = false;
      this.currentAddressData.Postcode = this.overseasAddressData.postcode;
      this.currentAddressData.StateProvinceRegion = this.overseasAddressData.state;
      this.currentAddressData.SuburbTownCity = this.overseasAddressData.suburb;
      this.currentAddressData.CountryId = this.overseasAddressData.country;
    }



    this.initialParentDetailsData = { ...this.parentDetailsData };
    this.initialPhoneNumberData = { ...this.phoneNumberData };
    this.initialAustralianAddressData = { ...this.australianAddressData };
    this.initialOverseasAddressData = { ...this.overseasAddressData };


    this.parentGuardianDetailsFormGroup.patchValue({
      studentDetails: this.parentDetailsData,
      phoneNumber: this.phoneNumberData,
      australianAddress: this.australianAddressData,//could ignore
      overseasAddress: this.overseasAddressData,//could ignore
      currentAddress: this.currentAddressData
    });
    this.parentGuardianDetailsFormGroup.updateValueAndValidity();

  }

  getAustralianAddress(parentGuardianDetails: ParentGuardianDetails): Address {
    return {
      line1: parentGuardianDetails.AustralianAddressLine1,
      line2: parentGuardianDetails.AustralianAddressLine2,
      suburb: parentGuardianDetails.AustralianSuburb,
      state: parentGuardianDetails.AustralianState,
      postcode: parentGuardianDetails.AustralianPostcode,
      country: '',
      isCurrentAddress: false
    };
  }

  getOverseasAddress(parentGuardianDetails: ParentGuardianDetails): Address {
    return {
      line1: parentGuardianDetails.OverseasAddressLine1,
      line2: parentGuardianDetails.OverseasAddressLine2,
      suburb: parentGuardianDetails.OverseasSuburbTown,
      state: parentGuardianDetails.OverseasStateProvinceRegion,
      postcode: parentGuardianDetails.OverseasPostcode,
      country: '',
      isCurrentAddress: false
    };
  }

  isThisFieldHasErrors(fieldName: string): boolean {
    return this.isFormSubmitted && this.parentGuardianDetailsFormGroup.get(fieldName).errors != null;
  }


  isThisFieldHasApiError(fieldName: string): boolean {
    return this.isFormSubmitted
      && this.parentGuardianDetailsFormGroup.get(fieldName).errors != null
      && this.parentGuardianDetailsFormGroup.get(fieldName).errors.api != null;
  }

  updateParentPersonDetails(parentGuardianDetails: ParentGuardianDetails, personDetails: PersonDetails) {
    parentGuardianDetails.RelationshipCode = personDetails.relationship;
    parentGuardianDetails.OtherRelationship = personDetails.otherRelationship;
    parentGuardianDetails.GivenName = personDetails.givenName;
    parentGuardianDetails.FamilyName = personDetails.familyName;
    parentGuardianDetails.OnlyHasOneName = personDetails.onlyHasOneName;
    parentGuardianDetails.CountryOfBirthId = personDetails.countryOfBirth;
    parentGuardianDetails.CountryOfNationalityId = personDetails.nationality;
    parentGuardianDetails.PreferredName = personDetails.preferredName;
    parentGuardianDetails.IsRefusedAusVisaBefore = personDetails.isRefusedAusVisaBefore;
    parentGuardianDetails.VisaRefusalDetails = personDetails.visaRefusalDetails;
    parentGuardianDetails.PassportNumber = personDetails.passportNumber;
    parentGuardianDetails.Gender = personDetails.gender;
    parentGuardianDetails.EmailAddress = personDetails.emailAddress;

    parentGuardianDetails.DateOfBirth = this.utilityService.getDateStrWithoutTimeZone(personDetails.dateOfBirth);

    // if (personDetails.dateOfBirth) {
    //   const dob = personDetails.dateOfBirth.split('/');
    //   const dateObject = new Date(+dob[2], (+dob[1] - 1), +dob[0]);
    //   const userTimezoneOffset = dateObject.getTimezoneOffset() * 60000;
    //   const date = new Date(dateObject.getTime() - userTimezoneOffset);
    //   parentGuardianDetails.DateOfBirth = date.toISOString();
    // }

  }

  updateParentPhoneNumberDetails(parentGuardianDetails: ParentGuardianDetails, phoneNumberDetails: PhoneNumberDetails) {
    parentGuardianDetails.MobileCountryCode = phoneNumberDetails.mobileCountryCode === '0' ? null : phoneNumberDetails.mobileCountryCode;
    parentGuardianDetails.MobilePhoneNumber = phoneNumberDetails.mobilePhoneNumber;
    parentGuardianDetails.HomeCountryCode = phoneNumberDetails.homeCountryCode === '0' ? null : phoneNumberDetails.homeCountryCode;
    parentGuardianDetails.HomePhoneNumber = phoneNumberDetails.homePhoneNumber;
  }

  updateParentAddress(parentGuardianDetails: ParentGuardianDetails, currentAddress: ParentAddress) {

    if (currentAddress.IsAustralianAddress) {
      parentGuardianDetails.AustralianAddressLine1 = currentAddress.AddressLine1;
      parentGuardianDetails.AustralianAddressLine2 = currentAddress.AddressLine2;
      parentGuardianDetails.AustralianSuburb = currentAddress.SuburbTownCity;
      parentGuardianDetails.AustralianState = currentAddress.StateProvinceRegion;
      parentGuardianDetails.AustralianPostcode = currentAddress.Postcode;
      parentGuardianDetails.IsAustralianAddressCurrentAddress = true;
    } else {
      parentGuardianDetails.OverseasAddressLine1 = currentAddress.AddressLine1;
      parentGuardianDetails.OverseasAddressLine2 = currentAddress.AddressLine2;
      parentGuardianDetails.OverseasSuburbTown = currentAddress.SuburbTownCity;
      parentGuardianDetails.OverseasStateProvinceRegion = currentAddress.StateProvinceRegion;
      parentGuardianDetails.OverseasCountryId = currentAddress.CountryId;
      parentGuardianDetails.OverseasPostcode = currentAddress.Postcode;
      parentGuardianDetails.IsOverseasAddressCurrentAddress = false;
    }

  }

  getParentGuardianDetails(): ParentGuardianDetails {

    const parentGuardianDetails = new ParentGuardianDetails();
    parentGuardianDetails.SchoolProgramType = this.schoolProgramTypeStr;
    parentGuardianDetails.ParentGuardianId = this.parentGuardianId;

    const parentPersonDetails = this.parentGuardianDetailsFormGroup.get('parentDetails').value;
    this.updateParentPersonDetails(parentGuardianDetails, parentPersonDetails);
    const phoneNumberDetails = this.parentGuardianDetailsFormGroup.get('phoneNumber').value;
    this.updateParentPhoneNumberDetails(parentGuardianDetails, phoneNumberDetails);

    const currentAddress = this.parentGuardianDetailsFormGroup.get('currentAddress').value;

    this.updateParentAddress(parentGuardianDetails, currentAddress);
    //const australianAddress = this.parentGuardianDetailsFormGroup.get('australianAddress').value;
    //this.updateParentAddress(parentGuardianDetails, australianAddress, this.currentAddressData.IsAustralianAddress);
    //const overseasAddress = this.parentGuardianDetailsFormGroup.get('overseasAddress').value;
    //this.updateParentAddress(parentGuardianDetails, overseasAddress, this.currentAddressData.IsAustralianAddress);

    //console.log("--Carer details about to save is:--", parentGuardianDetails);


    return parentGuardianDetails;
  }

  setApiValidationError(apiErrorKeyName: string,
    apiErrorMsg: string,
    parentDetailsErrors: PersonDetailsErrors,
    phoneNumberErrors: PhoneNumberErrors,
    australianAddressErrors: AddressErrors,
    overseasAddressErrors: AddressErrors): void {

    switch (apiErrorKeyName) {
      case 'RelationshipCode':
        parentDetailsErrors.relationship = apiErrorMsg;
        break;
      case 'OtherRelationship':
        parentDetailsErrors.otherRelationship = apiErrorMsg;
        break;
      case 'GivenName':
        parentDetailsErrors.givenName = apiErrorMsg;
        break;
      case 'FamilyName':
        parentDetailsErrors.familyName = apiErrorMsg;
        break;
      case 'PreferredName':
        parentDetailsErrors.preferredName = apiErrorMsg;
        break;
      case 'IsRefusedAusVisaBefore':
        parentDetailsErrors.isRefusedAusVisaBefore = apiErrorMsg;
        break;
      case 'VisaRefusalDetails':
        parentDetailsErrors.visaRefusalDetails = apiErrorMsg;
        break;
      case 'Gender':
        parentDetailsErrors.gender = apiErrorMsg;
        break;
      case 'DateOfBirth':
        parentDetailsErrors.dateOfBirth = apiErrorMsg;
        break;
      case 'CountryOfBirthId':
        parentDetailsErrors.countryOfBirth = apiErrorMsg;
        break;
      case 'CountryOfNationalityId':
        parentDetailsErrors.nationality = apiErrorMsg;
        break;
      case 'PassportNumber':
        parentDetailsErrors.passportNumber = apiErrorMsg;
        break;
      case 'EmailAddress':
        parentDetailsErrors.emailAddress = apiErrorMsg;
        break;
      case 'MobileCountryCode':
        phoneNumberErrors.mobileCountryCode = apiErrorMsg;
        break;
      case 'MobilePhoneNumber':
        phoneNumberErrors.mobilePhoneNumber = apiErrorMsg;
        break;
      case 'HomeCountryCode':
        phoneNumberErrors.homeCountryCode = apiErrorMsg;
        break;
      case 'HomePhoneNumber':
        phoneNumberErrors.homePhoneNumber = apiErrorMsg;
        break;
      case 'AustralianAddressLine1':
        australianAddressErrors.line1 = apiErrorMsg;
        this.currentAddressErrors.AddressLine1 = apiErrorMsg;
        break;
      case 'AustralianAddressLine2':
        australianAddressErrors.line2 = apiErrorMsg;
        this.currentAddressErrors.AddressLine2 = apiErrorMsg;
        break;
      case 'AustralianSuburb':
        australianAddressErrors.suburb = apiErrorMsg;
        this.currentAddressErrors.SuburbTownCity = apiErrorMsg;
        break;
      case 'AustralianState':
        australianAddressErrors.state = apiErrorMsg;
        this.currentAddressErrors.StateProvinceRegion = apiErrorMsg;
        break;
      case 'AustralianPostcode':
        australianAddressErrors.postcode = apiErrorMsg;
        this.currentAddressErrors.Postcode = apiErrorMsg;
        break;
      case 'IsAustralianAddressCurrentAddress':
        australianAddressErrors.isCurrentAddress = apiErrorMsg;
        break;
      case 'OverseasAddressLine1':
        overseasAddressErrors.line1 = apiErrorMsg;
        this.currentAddressErrors.AddressLine1 = apiErrorMsg;
        break;
      case 'OverseasAddressLine2':
        overseasAddressErrors.line2 = apiErrorMsg;
        this.currentAddressErrors.AddressLine2 = apiErrorMsg;
        break;
      case 'OverseasSuburbTown':
        overseasAddressErrors.suburb = apiErrorMsg;
        this.currentAddressErrors.SuburbTownCity = apiErrorMsg;
        break;
      case 'OverseasStateProvinceRegion':
        overseasAddressErrors.state = apiErrorMsg;
        this.currentAddressErrors.StateProvinceRegion = apiErrorMsg;
        break;
      case 'OverseasPostcode':
        overseasAddressErrors.postcode = apiErrorMsg;
        this.currentAddressErrors.Postcode = apiErrorMsg;
        break;
      case 'OverseasCountryId':
        overseasAddressErrors.country = apiErrorMsg;
        this.currentAddressErrors.CountryId = apiErrorMsg;
        break;
      case 'IsOverseasAddressCurrentAddress':
        overseasAddressErrors.isCurrentAddress = apiErrorMsg;
        break;
    }
  }


  setIsAustralianAddress(isAustralianAddress: boolean) {
    //("Is AustralianAddress?", isAustralianAddress);
    this.currentAddressData.IsAustralianAddress = isAustralianAddress;
  }

  saveParentGuardian() {

    const parentGuardianDetails = this.getParentGuardianDetails();
    this.isFormSubmitted = true;
    //console.log("--(1)-- ParentGuardian info to update is ====>", parentGuardianDetails);
    this.applicationService.updateParentGuardianDetails(this.applicationId, parentGuardianDetails)
      .subscribe((response: SingleResultApiResponse) => {
        this.dispatchSectionSaveAction();
        this.isSaveSuccessful = true;

        if (response.Result) {
          this.showChangeImpactModal = response.Result.IsDateOfBirthStatusChanged;
        }
        if (this.showChangeImpactModal === false) {
          this.router.navigate(['/applications', this.applicationId, 'edit', 'parent-guardian-details']);
        }else{
          setTimeout(() => {
            this.resolve.nativeElement.focus();
          }, 100);
        }
      }, (errorResponse: ErrorResponse) => {
        //console.log("--(2)-- Validation message error msg is ====>", errorResponse);

        const parentDetailsErrors: PersonDetailsErrors = {};
        const phoneNumberErrors: PhoneNumberErrors = {};
        const australianAddressErrors: AddressErrors = {};
        const overseasAddressErrors: AddressErrors = {};

        const { errors, result } = errorResponse;

        if (result && result.ParentGuardianId) {
          this.parentGuardianId = result.ParentGuardianId;
        }

        for (const error of errors) {
          this.setApiValidationError(error.Key,
            error.Value,
            parentDetailsErrors,
            phoneNumberErrors,
            australianAddressErrors,
            overseasAddressErrors);
        }

        this.parentDetailsErrors = parentDetailsErrors;
        this.phoneNumberErrors = phoneNumberErrors;
        this.australianAddressErrors = australianAddressErrors;
        this.overseasAddressErrors = overseasAddressErrors;

        //console.log("--(3.1)-- australianAddressErrors is ====>", australianAddressErrors);
        //console.log("--(3.2)-- overseasAddressErrors is ====>", overseasAddressErrors);
        //console.log("--(3.3)-- currentAddressErrors is ====>", this.currentAddressErrors);

        this.parentGuardianDetailsFormGroup.updateValueAndValidity();

        this.dispatchSectionSaveAction();
        this.reloadInitialData();
        this.isScrollDone = false;
        this.formService.scrollToFirstErrorField();
      });

  }

  dispatchSectionSaveAction() {
    this.store.dispatch({
      type: Action_ApplicationSectionSaved
    });
  }

  canDeactivate(): Observable<boolean> | boolean {

    if (this.isSaveSuccessful) {
      return true;
    }

    if (!this.isParentGuardianDetailsSame()) {
      this.modalService.showModal();
      return this.modalService.stayOnThePage;
    } else {
      this.modalService.hideModal();
      return true;
    }
  }

  ngAfterContentChecked(): void {
    if (!this.isScrollDone) {
      this.isScrollDone = this.formService.scrollToFirstErrorField();
    }

  }

  isParentGuardianDetailsSame(): boolean {
    const currentPersonDetails = this.parentGuardianDetailsFormGroup.get('parentDetails').value;
    const currentPhoneNumberDetails = this.parentGuardianDetailsFormGroup.get('phoneNumber').value;
    const currentAustralianAddressDetails = this.parentGuardianDetailsFormGroup.get('australianAddress').value;
    const currentOverseasAddressDetails = this.parentGuardianDetailsFormGroup.get('overseasAddress').value;

    const isParentGuardianDetailsSame = compareParentGuardianDetails(this.initialParentDetailsData, currentPersonDetails,
      this.initialPhoneNumberData, currentPhoneNumberDetails,
      this.initialAustralianAddressData, currentAustralianAddressDetails,
      this.initialOverseasAddressData, currentOverseasAddressDetails);

    return isParentGuardianDetailsSame;
  }

  updateAddressInParentGuardianDetails(parentGuardianDetails: ParentGuardianDetails, addressField: string): void {

    const address = <Address>this.parentGuardianDetailsFormGroup.get(addressField).value;

    if (addressField === 'australianAddress') {

      parentGuardianDetails.AustralianAddressLine1 = address.line1;
      parentGuardianDetails.AustralianAddressLine2 = address.line2;
      parentGuardianDetails.AustralianSuburb = address.suburb;
      parentGuardianDetails.AustralianState = address.state;
      parentGuardianDetails.AustralianPostcode = address.postcode;
      parentGuardianDetails.IsAustralianAddressCurrentAddress = address.isCurrentAddress;

    } else if (addressField === 'overseasAddress') {

      parentGuardianDetails.OverseasAddressLine1 = address.line1;
      parentGuardianDetails.OverseasAddressLine2 = address.line2;
      parentGuardianDetails.OverseasSuburbTown = address.suburb;
      parentGuardianDetails.OverseasStateProvinceRegion = address.state;
      parentGuardianDetails.OverseasPostcode = address.postcode;
      parentGuardianDetails.OverseasCountryId = address.country;
      parentGuardianDetails.IsOverseasAddressCurrentAddress = address.isCurrentAddress;

    }

  }

  cancelSaveParentGuardian(): void {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'parent-guardian-details']);
  }

  displayChangeImpactModal(): boolean {
    return this.showChangeImpactModal;
  }



}
